import React from 'react';
import { AppBar, Toolbar, Typography, Box, Chip, IconButton } from '@mui/material';
import { Menu as MenuIcon, TrendingUp as TradingIcon } from '@mui/icons-material';
import { useSecurityTier } from '../../contexts/SecurityTierContext';
import ThemeToggle from './ThemeToggle';
import ModeSwitch from './ModeSwitch';

interface HeaderProps {
  onMenuToggle: () => void;
  mode?: 'bitvavo' | 'ibkr';
  onModeChange?: (mode: 'bitvavo' | 'ibkr') => void;
}

const TIER_LABELS: Record<number, { label: string; color: 'info' | 'warning' | 'success' }> = {
  1: { label: 'Stufe 1 — Starter', color: 'info' },
  2: { label: 'Stufe 2 — Verifiziert', color: 'warning' },
  3: { label: 'Stufe 3 — Trader', color: 'success' },
};

const Header: React.FC<HeaderProps> = ({ onMenuToggle, mode, onModeChange }) => {
  const { tier } = useSecurityTier();
  const tierInfo = TIER_LABELS[tier] || { label: 'Unbekannt', color: 'info' as const };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'background.paper',
        color: 'text.primary',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Toolbar>
        <IconButton
          edge="start"
          onClick={onMenuToggle}
          aria-label="Menü umschalten"
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TradingIcon color="primary" sx={{ fontSize: 28 }} />
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
            <Typography variant="h6" fontWeight={700} color="primary" noWrap>
              BTRADER
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: 'text.secondary', fontWeight: 500, display: { xs: 'none', sm: 'inline' } }}
            >
              Krypto-Trading
            </Typography>
          </Box>
        </Box>

        {mode && onModeChange && (
          <ModeSwitch mode={mode} onChange={onModeChange} />
        )}

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Chip
            label={tierInfo.label}
            color={tierInfo.color}
            size="small"
            variant="outlined"
          />
          <ThemeToggle />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
